/* eslint-disable react/display-name */
/*
 * Author M. Atoar Rahman
 * Title: Facility Stock Receive Component To Print
 * Description: Component for Facility Stock Receive GRN Print
 * Date: 05/03/2025
 */

import React from 'react';
import moment from 'moment';
import { Col, Row, Table } from 'react-bootstrap';
import logo from '../../../../assets/unhcr-logo-blue.png';
import { useAuth } from '../../../../contexts/AuthContext';
import { useFacilityStockReceive } from '../ContextAPI';

const monthList = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const FacilityStockReceiveComponentToPrint = React.forwardRef((props, ref) => {
    const { pdfData } = useFacilityStockReceive();
    const { auth } = useAuth();
    const headerCellStyle = { border: '1px solid #dee2e6' };
    console.log("pdfData", pdfData);
    return (
        <fieldset ref={ref} className="customFieldset p-5">
            {/* Header Table */}
            <Row className="mb-0">
                <Col>
                    <Table
                        bordered
                        className="mb-0"
                        style={{ borderCollapse: 'collapse', border: '1px solid #dee2e6' }}
                    >
                        <tbody>
                            <tr>
                                <td
                                    width="33%"
                                    className="text-center align-middle"
                                    style={headerCellStyle}
                                >
                                    <img width="120px" src={logo} alt="UNHCR Logo" />
                                </td>
                                <td
                                    width="34%"
                                    className="text-center align-middle"
                                    style={headerCellStyle}
                                >
                                    <h5 className="mb-0">Goods Receiving Notes</h5>
                                    <h5 className="mb-0">(GRN)</h5>
                                </td>
                                <td
                                    width="33%"
                                    className="text-center align-middle"
                                    style={headerCellStyle}
                                >
                                    <h6 className="mb-0 d-none">NGO FORUM</h6>
                                    <small className='d-none'>FOR PUBLIC HEALTH</small>
                                </td>
                            </tr>
                            <tr>
                                <td width="25%" style={headerCellStyle}>
                                    <b>Facility</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>{pdfData?.facility_name}</td>
                                <td width="25%" style={headerCellStyle}>
                                    <b>GRN Number</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>{pdfData?.grn_no || pdfData?.grn_number || ''}</td>
                            </tr>
                            <tr>
                                <td width="25%" style={headerCellStyle}>
                                    <b>Year</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>{pdfData?.year}</td>
                                <td width="25%" style={headerCellStyle}>
                                    <b>Prepared By</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>
                                    {auth?.employee_info?.first_name
                                        ? `${auth?.employee_info?.first_name} ${auth?.employee_info?.last_name || ''}`
                                        : auth?.users?.username || ''}
                                </td>
                            </tr>
                            <tr>
                                <td width="25%" style={headerCellStyle}>
                                    <b>Month</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>
                                    {monthList[Number(pdfData?.month)] || ''}
                                </td>
                                <td width="25%" style={headerCellStyle}> </td>
                                <td width="25%" style={headerCellStyle}> </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>

            {/* Body Table */}
            <Row className="mb-0">
                <Col>
                    <Table striped bordered hover className="mb-0">
                        <thead>
                            <tr>
                                <th>SL</th>
                                <th>Item Name</th>
                                <th>Expiry Date</th>
                                <th>Approved Qty</th>
                                <th>Supplied Qty</th>
                                <th>Received Qty</th>
                                <th>Rejected Qty</th>
                                <th>Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pdfData?.records && pdfData?.records.length > 0 ? (
                                pdfData?.records
                                    .filter((record) => record.supplied_qty || record.receive_qty)
                                    .map((record, index) => (
                                        <tr key={record.drug_id || `record-${index}`}>
                                            <td>{index + 1}</td>
                                            <td>{record.drug_name || ''}</td>
                                            <td>
                                                {record.expiry_date || record.earliest_expire_date
                                                    ? moment(record.expiry_date || record.earliest_expire_date).format('DD MMM YYYY')
                                                    : ''}
                                            </td>
                                            <td>{record.approved_qty || 0}</td>
                                            <td>{record.supplied_qty || '0'}</td>
                                            <td>{record.receive_qty || '0'}</td>
                                            <td>{record.rejected_qty || '0'}</td>
                                            <td>{record.rejected_reason || ''}</td>
                                        </tr>
                                    ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        No records available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>

            {/* Footer Table */}
            <Row className="mb-0">
                <Col>
                    <Table bordered className="mb-0">
                        <tbody>
                            <tr>
                                <td width="33%"> </td>
                                <td width="33%">
                                    <b>Prepared by: (Receiver)</b>
                                </td>
                                <td width="34%">
                                    <b>Acknowledged by: (Supplier Representative / Driver)</b>
                                </td>
                            </tr>
                            <tr>
                                <td width="33%">Signature with date</td>
                                <td width="33%" height="80px"> </td>
                                <td width="34%" height="80px"> </td>
                            </tr>
                            <tr>
                                <td width="33%">Name</td>
                                <td width="33%"> </td>
                                <td width="34%"> </td>
                            </tr>
                            <tr>
                                <td width="33%">Designation</td>
                                <td width="33%"> </td>
                                <td width="34%"> </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </fieldset>
    );
});

export default FacilityStockReceiveComponentToPrint;
